import { render } from "./IndexFeature.vue?vue&type=template&id=2313db8c"
import script from "./IndexFeature.vue?vue&type=script&lang=js"
export * from "./IndexFeature.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/cradle.staging.moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__